import { IAuditResponse, IAuditDetailResponse } from "../../../model/base/response/audit-response";
import { Pagination } from "../../../model/paginatiion";

export type AuditsState = {
    audits: Pagination<IAuditResponse>;
    auditDetail: IAuditDetailResponse | null;
};

export enum ACTION_TYPES {
    SET_AUDITS = 'SET_AUDITS',
    CLEAR_AUDITS = 'CLEAR_AUDITS',
    SET_AUDIT_DETAIL = 'SET_AUDIT_DETAIL',
}

export const initialState: AuditsState = {
    audits: new Pagination<IAuditResponse>(),
    auditDetail: null
};

export const AuditsReducer = (state: AuditsState, action: any): AuditsState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.SET_AUDITS:
            return {
                ...state,
                audits: payload,
            };
        case ACTION_TYPES.CLEAR_AUDITS:
            return {
                ...state,
                audits: new Pagination<IAuditResponse>(),
            };
        case ACTION_TYPES.SET_AUDIT_DETAIL:
            return {
                ...state,
                auditDetail: payload,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
